import { createSlice } from '@reduxjs/toolkit';

export const ErrorsSlice = createSlice({
  name: 'errors',
  initialState: {
    has_errors: false,
    icon_request_has_errors: false,
  },
  reducers: {
    setErrorsRedux: (state) => {
      state.has_errors = true;
    },
    removeErrorsRedux: (state) => {
      state.has_errors = false;
    },
    showIconRequestErrors: (state) => {
      state.icon_request_has_errors = true;
    },
    hideIconRequestErrors: (state) => {
      state.icon_request_has_errors = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setErrorsRedux, removeErrorsRedux, showIconRequestErrors, hideIconRequestErrors } =
  ErrorsSlice.actions;
